var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sr-input-label"},[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.required)?_c('div',{staticClass:"required-indicator"},[_vm._v("*")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }